import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'ContactForm',

  components: {
    ShButton,
  },

  data() {
    return {
      formData: {
        sender: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        isRodoAccepted: false,
      },
      validationRules: {
        sender: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
        email: { required: true, validator: this.emailValidator, trigger: 'blur' },
        subject: { required: true, message: 'Pole jest wymagane', trigger: 'change' },
        message: { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
        phone: { required: true, validator: this.phoneNumberValidator, trigger: 'blur' },
        isRodoAccepted: { required: true, validator: this.rodoValidator, trigger: 'change' },
      },
    };
  },

  methods: {
    handleCloseModalWindow() {
      this.$emit('handleCloseModalWindow');
    },
    handleSendEmail() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch('contactFormSendMail/send', {
            email: this.formData.email,
            number: this.formData.phone,
            sender: this.formData.sender,
            rodo: this.mailSettings.rodo,
            message: this.formData.message,
            subject: this.formData.subject,
            mail_to: this.mailSettings.mail_to,
            mail_template: this.mailSettings.mail_template,
          });
          this.handleCloseModalWindow();
          this.$message.success('Zgłoszenie wysłane poprawnie.');
        }
      });
    },
    emailValidator(rule, value, callback) {
      if (!value) {
        callback(new Error('Adres e-mail jest wymagany'));
      }
      // eslint-disable-next-line no-useless-escape
      if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) {
        callback(new Error('Nieprawidłowy adres e-mail'));
      }
      callback();
    },
    rodoValidator(rule, value, callback) {
      if (!value) {
        callback(new Error('To pole jest wymagane'));
      }
      if (value !== true) {
        callback(new Error('To pole jest wymagane'));
      }
      callback();
    },
    phoneNumberValidator(rule, value, callback) {
      if (!value) {
        callback(new Error('Numer telefonu jest wymagany'));
      }
      // eslint-disable-next-line no-useless-escape
      if (!(/^\d{9}$/).test(value)) {
        callback(new Error('Prawidłowy numer telefonu zawiera 9 cyfr'));
      }
      callback();
    },
  },

  computed: {
    user() {
      return this.$store.getters['authorization/user'];
    },
    subjectCategories() {
      return this.$store.getters['contactFormCategories/list'];
    },
    mailSettings() {
      return this.$store.getters['contactFormSettings/list'];
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'contactFormSendMail/send',
        'contactFormSettings/getList',
        'contactFormCategories/getList',
      ]);
    },
    isSending() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'contactFormSendMail/send',
      ]);
    },
  },

  created() {
    this.$store.dispatch('contactFormCategories/getList');
    this.$store.dispatch('contactFormSettings/getList');
    this.formData.sender = `${this.user.name} ${this.user.last_name}`;
    this.formData.email = this.user.email;
    this.formData.phone = this.user.phone_number;
  },
};
